export const maskValue = (mask: boolean | undefined, value: string) => {
  if (!mask || value === '--' || value.length <= 4) {
    return value;
  }

  const last = value.slice(-4);
  const stars = '*'.repeat(value.length - 4);
  return `${stars}${last}`;
};
